import "./ClassicyDesktopMenuWidgetSound.scss";
import "@/SystemFolder/SystemResources/Menu/ClassicyMenu.scss";
import classNames from "classnames";
import type {
	FC as FunctionalComponent,
	KeyboardEvent,
	MouseEvent,
} from "react";
import { ClassicyIcons } from "@/SystemFolder/ControlPanels/AppearanceManager/ClassicyIcons";
import { useAppManagerDispatch } from "@/SystemFolder/ControlPanels/AppManager/ClassicyAppManagerUtils";
import {
	useSound,
	useSoundDispatch,
} from "@/SystemFolder/ControlPanels/SoundManager/ClassicySoundManagerContext";

const appIcon = ClassicyIcons.controlPanels.soundManager.app;
const soundOffImg = ClassicyIcons.controlPanels.soundManager.soundOff;
const soundOnImg = ClassicyIcons.controlPanels.soundManager.soundOn;

type ClassicyDesktopMenuWidgetSoundProps = {
	hide?: boolean;
};

export const ClassicyDesktopMenuWidgetSound: FunctionalComponent<
	ClassicyDesktopMenuWidgetSoundProps
> = ({ hide = false }) => {
	const player = useSoundDispatch();
	const playerState = useSound();
	const desktopEventDispatch = useAppManagerDispatch();

	const openSoundManager = (e: MouseEvent) => {
		e.preventDefault();
		desktopEventDispatch({
			type: "ClassicyAppOpen",
			app: {
				id: "SoundManager.app",
				name: "Sound Manager",
				icon: appIcon,
			},
		});
	};

	const mute = () => {
		player({
			type: "ClassicySoundDisable",
			disabled: playerState.disabled.includes("*") ? [] : ["*"],
		});
		return;
	};

	return (
		<>
			{!hide && (
				<li
					className={classNames(
						"classicyDesktopMenuWidgetSound",
						"classicyMenuItem",
						"classicyMenuItemNoImage",
					)}
					onClick={mute}
					onDoubleClick={openSoundManager}
					onKeyDown={(e: KeyboardEvent) => {
						if (e.key === "Enter" || e.key === " ") {
							e.preventDefault();
							mute();
						}
					}}
				>
					<img
						src={playerState.disabled.includes("*") ? soundOffImg : soundOnImg}
						alt={playerState.disabled.includes("*") ? "Unmute" : "Mute"}
					/>
				</li>
			)}
		</>
	);
};
